import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import styled, { css } from "styled-components";
import {
  handleAddLocations,
  handleAddMachines,
  handleAddSpecificLocations,
  handleLocationSelect,
  handleMachineSelect,
  handleResetAllSelect,
  handleSelectAll,
  handleSelectedOne,
  handleSpecificLocationSelect,
  selectMasterControls,
} from "../../store/slices/masterControlSelectSlice";
import {
  handleApplyCommand,
  handleControlResetInit,
  handleCreateCommand,
  handleSearchCommand,
  handleViewCommand,
  handleViewPrevCommandAndCreateNewCommand,
  selectMCCommand,
} from "../../store/slices/mCCommandSlice";
import { handleApplyMessageBox } from "../../store/slices/messageBoxesSlice";
import {
  flexBoxCenter,
  justifyContentSpaceAround,
  layerA180Deg,
  layerBDark,
} from "../../styles/commonStyles";
import CommandSelectionsApplyButton from "./CommandSelectionsApplyButton";
import ShareComponent from "./ShareComponent";
import { handleSelectSystem } from "../../store/slices/mCSlice";
import {
  essSpecificLocationSelectMachinesHandler,
  handleSelectIndividualMachine,
  handleUnSelectIndividualMachine,
  selectEssSwitch,
} from "../../store/slices/essSwitchSlice";
import {
  selectTgsSwitch,
  tgsHandleSelectIndividualMachine,
  tgsHandleUnSelectIndividualMachine,
  tgsSpecificLocationSelectMachinesHandler,
} from "../../store/slices/tgsSwitchSlice";
import {
  selectTesSwitch,
  tesHandleSelectIndividualMachine,
  tesHandleUnSelectIndividualMachine,
  tesSpecificLocationSelectMachinesHandler,
} from "../../store/slices/tesSwitchSlice";
import {
  AddScheduleHandlerTempo,
  constantHeatHandlerTempo,
  fanOnlyHandlerTempo,
  handleAllDeactivatePrograms,
  handleResetAll,
  instantHeatHandlerTempo,
  snowSensorHandlerTempo,
  toggleAtsHandlerTempo,
  windFactorHandlerTempo,
} from "../../store/slices/selectedMachinesSlice";
import { useContext } from "react";
import { MasterControlContext } from "../MaterControlContext";
import { selectUserInfo } from "../../store/slices/userSlice";
import { handleSetUnits } from "../../store/slices/settings/unitsSlice";
import { readableTime, savedCommandTempToCelsius } from "../../../helpers/helpers";
import { selectLocations } from "../../store/slices/locationsSlice";
import testData from "../../../test_data/testData";
import {
  selectLocationsHandler,
  selectMachinesHandler,
  selectSpecificLocationsHandler,
  switchCountHandler,
  unselectAllMachinesHandler,
} from "../../../hooks/useSelectSwitchesDispatches";

function MasterControlCommandMain({
  handleMessageBox,
  selectedSwitches,
  setSelectedSwitches,
  handleCreateNewCommandMessageBox,
  hasProgramChanges,
  showNoChangesMessage,
}) {
  const dispatch = useDispatch();
  const mCCommandState = useSelector(selectMCCommand);
  const selectSwitch = useSelector(selectMasterControls);
  const viewCommandState = mCCommandState.viewCommand;
  const essSwitchState = useSelector(selectEssSwitch);
  const tgsSwitchState = useSelector(selectTgsSwitch);
  const tesSwitchState = useSelector(selectTesSwitch);

  const { essSwitch, flatEssSwitch } = essSwitchState;
  const { tesSwitch, flatTesSwitch } = tesSwitchState;
  const { tgsSwitch, flatTgsSwitch } = tgsSwitchState;

  const UserState = useSelector(selectUserInfo);
  const userID = UserState.user.user_id;

  const {
    greenDetour,
    setGreenDetour,
    setSelectPrograms,
    setIsSelectedForAts,
    setResetDialControl,
  } = useContext(MasterControlContext);

  const [openingSelectionBox, setOpeningSelectionBox] = useState(false);
  const [selectCommand, setSelectCommand] = useState({});

  const checkIsThereACommandSelected = Object.keys(selectCommand).length > 0;
  const userCommandInfo =
    checkIsThereACommandSelected &&
    mCCommandState.commandsInfo[selectCommand.userId];

  const title =
    checkIsThereACommandSelected === false || !viewCommandState
      ? "view commands"
      : selectCommand.command;

  const handleOpenViewCommandBox = (idx, e) => {
    e.stopPropagation();
    switch (idx) {
      case 0:
        dispatch(handleControlResetInit(true));
        break;
      case 1:
        setResetDialControl(false);
        dispatch(handleControlResetInit(false));
        break;
      default:
        break;
    }
    setOpeningSelectionBox(!openingSelectionBox);
  };

  const handleApplyButton = (e) => {
    e.stopPropagation();

    if (
      !selectSwitch.ess.selectedOne &&
      !selectSwitch.tes.selectedOne &&
      !selectSwitch.tgs.selectedOne
    ) {
      return;
    }

    if (!hasProgramChanges) {
      showNoChangesMessage();
      return;
    }

    dispatch(handleApplyMessageBox(true));
    handleMessageBox();
    dispatch(handleViewCommand(false));
    dispatch(handleControlResetInit(false));
  };

  const handleCreateNewCommand = () => {
    dispatch(handleCreateCommand());
    dispatch(handleApplyCommand(false));
  };

  const handleCommandResetSystem = () => {

    dispatch(handleResetAll());
  };

  const handlesSelectedMachinesOfSelectedCommand = (
    swt,
    isSelected,
    data,
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedSpecificLocations,
    selectedMachines,
    selectedLocations
  ) => {
    const locations = Object.keys(data);
    switchCountHandler(isMachineSelected, swt, dispatch);

    if (isAllSelected) {
      dispatch(handleSelectedOne({ switch: swt, selectedOne: "all" }));
      selectLocationsHandler(locations, swt, data, dispatch);
    } else if (isLocationSelected.indexOf(true) !== -1) {
      selectLocationsHandler(selectedLocations, swt, data, dispatch);

      if (selectedSpecificLocations.length > 0) {
        selectSpecificLocationsHandler(
          selectedSpecificLocations,
          swt,
          data,
          dispatch
        );
      }

      if (selectedMachines.length > 0) {
        selectMachinesHandler(selectedMachines, swt, data, dispatch);
      }

    } else if (isSpecificLocationSelected.indexOf(true) !== -1) {
      selectSpecificLocationsHandler(
        selectedSpecificLocations,
        swt,
        data,
        dispatch
      );

      if (selectedMachines.length > 0) {
        selectMachinesHandler(selectedMachines, swt, data, dispatch);
      }

    } else if (selectedMachines.length > 0) {
      selectMachinesHandler(selectedMachines, swt, data, dispatch);

    } else if (!isSelected) {
      dispatch(handleSelectedOne({ switch: swt, selectedOne: null }));
    }
  };

  const commandSelectMachinesHandler = (
    selectedLocations,
    selectedSpecificLocations,
    selectedMachines,
    selectedSystemAbr,
    switchesData
  ) => {
    if (!selectSwitch[selectedSystemAbr].selectedOne) {
      const locations = Object.keys(switchesData);
      const isAllSelected =
        selectedLocations.length === locations.length ? true : false;
      dispatch(
        handleSelectAll({
          switch: selectedSystemAbr,
          status: isAllSelected,
        })
      );
      const locationArr = locations.map((location) =>
        selectedLocations.some(
          (selectedLocation) => selectedLocation === location
        )
      );
      dispatch(
        handleLocationSelect({ arr: locationArr, switch: selectedSystemAbr })
      );

      const newSelectLocations = [];
      locationArr.forEach((location, idx) => {
        if (location) {
          newSelectLocations.push(locations[idx]);
        }
      });

      dispatch(
        handleAddLocations({
          switch: selectedSystemAbr,
          arr: newSelectLocations,
        })
      );

      let newSpecificLocationList = [];
      let isSpecificLocationSelected = [];

      if (selectedSpecificLocations) {
        const specificLocationState = selectedSpecificLocations
          .filter((specLocation) => specLocation.length > 0)
          .map((el) => el.map((_) => true));

        dispatch(
          handleSpecificLocationSelect({
            arr: specificLocationState,
            switch: selectedSystemAbr,
          })
        );

        const newSpecLocation = [];
        selectedSpecificLocations.forEach((specLocation) =>
          specLocation.forEach((el) => newSpecLocation.push(el))
        );
        dispatch(
          handleAddSpecificLocations({
            arr: newSpecLocation,
            switch: selectedSystemAbr,
          })
        );
        newSpecificLocationList = newSpecLocation;
        isSpecificLocationSelected = specificLocationState;
      }

      const machines = Object.values(switchesData);
      const machineNewArr = [];
      const machineArr = machines.map((location) => {
        const machineNamesArr = [];
        machineNewArr.push(machineNamesArr);
        return Object.entries(location).map(([key, value]) => {
          const specificLocationMachines = [];
          if (value?.deviceMac) {
            machineNamesArr.push(key);
            return selectedMachines.some(
              (selectedMachine) => selectedMachine === key
            );
          } else {
            machineNamesArr.push(specificLocationMachines);
            return Object.keys(value).map((el) => {
              specificLocationMachines.push(key, el);
              return selectedMachines.some(
                (selectedMachine) => selectedMachine === el
              );
            });
          }
        });
      });

      dispatch(
        handleMachineSelect({ arr: machineArr, switch: selectedSystemAbr })
      );

      const newSelectedMachineArr = [];
      machineArr.forEach((location, locationIdx) => {
        if (location.length > 0) {
          location.forEach((el, elIdx) => {
            if (typeof el === "object") {
              el.forEach((machine) => {
                if (machine) {
                  newSelectedMachineArr.push([
                    locations[locationIdx],
                    machineNewArr[locationIdx][elIdx][0],
                    machineNewArr[locationIdx][elIdx][1],
                  ]);
                }
              });
            } else if (el) {
              newSelectedMachineArr.push([
                locations[locationIdx],
                machineNewArr[locationIdx][elIdx],
              ]);
            }
          });
        }
      });

      dispatch(
        handleAddMachines({
          switch: selectedSystemAbr,
          arr: newSelectedMachineArr,
        })
      );

      const machinesArrLength = newSelectedMachineArr.length;

      handlesSelectedMachinesOfSelectedCommand(
        selectedSystemAbr,
        machinesArrLength,
        switchesData,
        isAllSelected,
        locationArr,
        isSpecificLocationSelected,
        machineArr,
        newSpecificLocationList,
        newSelectedMachineArr,
        newSelectLocations
      );

    }
  };

  const handleSetPrevCommandSelectedMachines = (
    selectedSystemAbr,
    commandInfo
  ) => {
    const selectedLocations = commandInfo.locations;
    const selectedSpecificLocations = commandInfo?.specificLocations;
    const selectedMachines = commandInfo.machines
      .reduce((prev, curr) => prev.concat(curr), [])
      .map((el) => el);

    const switchesData =
      selectedSystemAbr === "ess"
        ? flatEssSwitch
        : selectedSystemAbr === "tes"
        ? flatTesSwitch
        : flatTgsSwitch;
    commandSelectMachinesHandler(
      selectedLocations,
      selectedSpecificLocations,
      selectedMachines,
      selectedSystemAbr,
      switchesData
    );

  };

  const handleSetPrevCommandSelectedAts = (selectedSysAbr, commandInfo) => {
    dispatch(
      toggleAtsHandlerTempo({
        swt: selectedSysAbr,
        selections: [
          commandInfo.ats.reactivate,
          commandInfo.ats.block,
          commandInfo.ats?.activateTgs ? commandInfo.ats?.activateTgs : false,
        ],
      })
    );

    if (commandInfo.ats.reactivate) {
      setIsSelectedForAts([true, false, false]);
    } else if (commandInfo.ats.block) {
      setIsSelectedForAts([false, true, false]);
    } else if (commandInfo.ats?.activateTgs) {
      setIsSelectedForAts([false, false, true]);
    }
  };

  const handleSetPrevCommandSelectedDeactivate = (commandInfo) => {
    dispatch(handleAllDeactivatePrograms(commandInfo.deactivate));

    setSelectPrograms(commandInfo.deactivate);

    const copyGreenDetourArr = [...greenDetour];
    if (Object.values(commandInfo.deactivate).some((value) => value)) {
      copyGreenDetourArr[1] = true;
    }
    if (
      commandInfo.ats.reactivate ||
      commandInfo.ats.block ||
      commandInfo.ats?.activateTgs
    ) {
      copyGreenDetourArr[0] = true;
    } else {
      copyGreenDetourArr[0] = false;
    }
    setGreenDetour(copyGreenDetourArr);
  };

  const handleSetPrevSelectedCommandDialControl = (commandInfo) => {
    const {
      instantHeat,
      snowSensor,
      optionalConstantTemp,
      heatingSchedule,
      windFactor,
      fanOnly = null,
    } = commandInfo.parameters;
    const { isF } = commandInfo;
    dispatch(handleSetUnits(isF));
    if (instantHeat) {
      dispatch(
        instantHeatHandlerTempo({
          temp: savedCommandTempToCelsius(instantHeat, isF),
          state: true,
        })
      );
    }
    if (snowSensor) {
      dispatch(snowSensorHandlerTempo(true));
    }
    if (optionalConstantTemp) {
      dispatch(
        constantHeatHandlerTempo({
          temp: savedCommandTempToCelsius(optionalConstantTemp, isF),
        })
      );
    }
    if (heatingSchedule) {
      const newHeatingSchedule = heatingSchedule.split("|");
      dispatch(
        AddScheduleHandlerTempo({
          inputTemp: savedCommandTempToCelsius(newHeatingSchedule[0], isF),
          start: readableTime(newHeatingSchedule[1]),
          end: readableTime(newHeatingSchedule[2]),
        })
      );
    }
    if (windFactor) {
      dispatch(windFactorHandlerTempo(true));
    }
    if (fanOnly) {
      dispatch(fanOnlyHandlerTempo(true));
    }
    setResetDialControl(false);
  };

  const handleSetPrevCommandSelectedSys = () => {
    const searchedCommand = userCommandInfo.filter(
      (userCommand) => Object.keys(userCommand)[0] === selectCommand.command
    );

    const selectedSystem =
      searchedCommand[0][selectCommand.command].system.split("-")[0];

    dispatch(handleSelectSystem(selectedSystem));

    const commandInfo = Object.values(searchedCommand[0])[0];
    handleSetPrevCommandSelectedMachines(selectedSystem, commandInfo);

    handleSetPrevCommandSelectedAts(selectedSystem, commandInfo);

    handleSetPrevCommandSelectedDeactivate(commandInfo);

    handleSetPrevSelectedCommandDialControl(commandInfo);
  };

  const handleDisplayViewCommand = () => {
    if (checkIsThereACommandSelected) {
      handleCommandResetSystem();
      handleCreateNewCommand();
      handleSetPrevCommandSelectedSys();

      dispatch(handleSearchCommand(selectCommand));
      setOpeningSelectionBox(false);
    }
  };

  const handleSelectCommand = (el) => {
    setSelectCommand({ command: el, userId: userID });
    dispatch(handleResetAllSelect());
    dispatch(handleResetAll());
    setResetDialControl(true);

    const searchedCommand = mCCommandState.commandsInfo[userID].filter(
      (userCommand) => Object.keys(userCommand)[0] === el
    );

    const selectedSystem = searchedCommand[0][el].system.split("-")[0];

    let locations = [];
    switch (selectedSystem) {
      case "ess":
        locations = Object.keys(essSwitch);
        unselectAllMachinesHandler(
          locations,
          selectedSystem,
          essSwitch,
          dispatch
        );
        break;
      case "tgs":
        locations = Object.keys(tgsSwitch);
        unselectAllMachinesHandler(
          locations,
          selectedSystem,
          tgsSwitch,
          dispatch
        );
        break;
      case "tes":
        locations = Object.keys(tesSwitch);
        unselectAllMachinesHandler(
          locations,
          selectedSystem,
          tesSwitch,
          dispatch
        );
        break;
      default:
        break;
    }
  };

  return (
    <WrapperBase>
      <Wrapper>
        <ShareComponent
          selectedSwitches={selectedSwitches}
          setSelectedSwitches={setSelectedSwitches}
        />
        <CommandSelectionsApplyButton
          viewCommandTitle={title}
          buttonsTitle={"apply"}
          handleViewCommandsList={handleOpenViewCommandBox}
          openingSelectionBox={openingSelectionBox}
          handleApplyButton={handleApplyButton}
          selectCommand={selectCommand}
          handleDisplayViewCommand={handleDisplayViewCommand}
          handleSelectCommand={handleSelectCommand}
          handleCreateNewCommandMessageBox={handleCreateNewCommandMessageBox}
        />
      </Wrapper>
    </WrapperBase>
  );
}

export default MasterControlCommandMain;

const WrapperBase = styled.div`
  width: 304px;
  height: 557px;

  ${layerBDark}

  border-radius: 7px;

  ${flexBoxCenter}
`;

const Wrapper = styled.div`
  width: 302px;
  height: 557px;

  ${layerA180Deg}

  border-radius: 6px;

  ${justifyContentSpaceAround}
  flex-direction: column;
`;
